import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-profile-black',
  templateUrl: './icon-profile-black.component.html',
  styles: []
})
export class IconProfileBlackComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
